
angular.module('admin')
.controller('WorkflowBoxController', function() {
	var self = this;
	
})
.directive('workflowbox', function(FormService, CurrentUser) {
    return {
    	templateUrl: 'framework/partials/admin/field-workflowbox.html',
    	scope: {
    		object: '=*',
    		reload: '&',
    		field: '=',  // workflow field
    	},
    	bindToController: true,
    	controller: function($scope, $translate, FormService) {
    		var self = this;
    		this.states = null;
    		this.transitions = null;
    		this.Object = this.object;
    		
    		/*self.Object[self.field.name + '__states']().then(function(states){
				self.states = states;
			});*/
			self.states = self.field.dictionary;
    		
    		$scope.$watch(function(){return self.Object.rec_id}, function() {
    			if (!self.Object || !self.Object.id) return;
				
				self.Object[self.field.name + '__transitions']().then(function(transitions){
					self.transitions = transitions;
				});
				
			});		
    		this.make = function(transition) {
    			console.log('make', transition);
    			var t = transition;
    			var formdata = this.Object.getClass().getObjectPayload(this.Object);
				formdata.target = t.target;
    			//var formdata = {target: t.target};
    			var form = {
    				title:t.name, 
					btn:t.name, 
    				prompt: $translate.instant('Are you sure you want to transition to:') + ' ' + $translate.instant(t.target_name) + '?', 
    				params: t.params? self.Object.get_form_params(t.params) : [],
					layout: [['edit']],
					submit: function(data) {
						return self.Object[self.field.name + '__state'](data).then(function(result){
							return self.reload({}).then(function(){return result;});
						});
					}
    			};
    			
    			var form = FormService.activateFormModal(form, formdata);
    		}
    		

			// do we need this?
    		this.hasPerm = function(permissions) {
    			var user = CurrentUser.instance;
    			if (typeof permissions === "string") permissions = [permissions];
    			for (var i=0; i<=permissions.length; i++) {
    				if (self.Object.__perms && self.Object.__perms[permissions[i]]) {
    					return true;
    				}
    			}
    			return false;
    		}
    		
    		window.$workflowscope = $scope;
    	},
    	controllerAs: 'workflow',
    }
})


